import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, defineProperty as _defineProperty, assertThisInitialized as _assertThisInitialized, createClass as _createClass, objectSpread2 as _objectSpread2, toConsumableArray as _toConsumableArray, extends as _extends, typeof as _typeof, objectWithoutProperties as _objectWithoutProperties, toPropertyKey as _toPropertyKey } from '../../_virtual/_rollupPluginBabelHelpers.js';
import _pt from '../../node_modules/prop-types/index.js';
import React from 'react';
import memoizeOne from '../../node_modules/memoize-one/dist/memoize-one.esm.js';
import FormContext$1 from './FormContext.js';
import { FormChangeSource } from './constants.js';
import { shouldFieldUpdate, fieldFormState, shallowCompareArrays, omitProps, isValueSet } from './utils.js';
import { minLength } from './validators/minLength.js';
import { maxLength } from './validators/maxLength.js';

var ArrayItemProvider = /*#__PURE__*/function (_React$Component) {
  _inherits(ArrayItemProvider, _React$Component);

  var _super = _createSuper(ArrayItemProvider);

  function ArrayItemProvider() {
    var _this;

    _classCallCheck(this, ArrayItemProvider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {});

    _defineProperty(_assertThisInitialized(_this), "_prevChangeMetadata", undefined);

    _defineProperty(_assertThisInitialized(_this), "_prevChangeValue", undefined);

    _defineProperty(_assertThisInitialized(_this), "getArrayContext", memoizeOne(function (arrayIndex, value, parentValue, formValue, onChange, errors, onError, onRemove, showErrors, allErrors, animateErrors, disabled, readOnly, previousChange, previousFormChange) {
      return {
        arrayIndex: arrayIndex,
        value: value,
        parentValue: parentValue,
        formValue: formValue,
        onChange: onChange,
        errors: errors,
        onError: onError,
        onRemove: onRemove,
        showErrors: showErrors,
        allErrors: allErrors,
        animateErrors: animateErrors,
        disabled: disabled,
        readOnly: readOnly,
        previousChange: previousChange,
        previousFormChange: previousFormChange
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "onChange", function (field, data, applyChanges, metadata) {
      // keep track of the previous change state
      _this._prevChangeMetadata = metadata;
      _this._prevChangeValue = _this.props.value;

      _this.props.onChange(_this.props.value, field, data, applyChanges, metadata);
    });

    _defineProperty(_assertThisInitialized(_this), "onRemove", function () {
      if (_this.props.index === undefined) return;

      _this.props.onRemove(_this.props.index);
    });

    _defineProperty(_assertThisInitialized(_this), "onError", function (field, errors, applyErrors) {
      _this.props.onError(_this.props.value, field, errors, applyErrors);
    });

    return _this;
  }

  _createClass(ArrayItemProvider, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return shouldFieldUpdate(this.props, nextProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          index = _this$props.index,
          value = _this$props.value,
          parentValue = _this$props.parentValue,
          formValue = _this$props.formValue,
          errors = _this$props.errors,
          showErrors = _this$props.showErrors,
          allErrors = _this$props.allErrors,
          animateErrors = _this$props.animateErrors,
          disabled = _this$props.disabled,
          readOnly = _this$props.readOnly,
          previousFormChange = _this$props.previousFormChange,
          children = _this$props.children; // determine if the array value corresponds with the metadata of the previous change

      var previousChange = this._prevChangeValue === this.state.prevValue ? this._prevChangeMetadata : undefined;
      var arrayContext = this.getArrayContext(index, value, parentValue, formValue, this.onChange, errors, this.onError, this.onRemove, showErrors, allErrors, animateErrors, disabled, readOnly, previousChange, previousFormChange);
      return /*#__PURE__*/React.createElement(FormContext$1.Provider, {
        value: arrayContext
      }, typeof children === "function" ? children(fieldFormState(arrayContext)) : children);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      // keep track of the previous form value
      if (props.value !== state.value) {
        return {
          value: props.value,
          prevValue: state.value
        };
      }

      return null;
    }
  }]);

  return ArrayItemProvider;
}(React.Component);

_defineProperty(ArrayItemProvider, "propTypes", {
  index: _pt.number,
  value: _pt.any.isRequired,
  parentValue: _pt.any.isRequired,
  formValue: _pt.any.isRequired,
  onChange: _pt.func.isRequired,
  errors: _pt.any.isRequired,
  onError: _pt.func.isRequired,
  showErrors: _pt.bool.isRequired,
  allErrors: _pt.bool.isRequired,
  animateErrors: _pt.oneOfType([_pt.number, _pt.bool]).isRequired,
  disabled: _pt.bool.isRequired,
  readOnly: _pt.bool.isRequired,
  previousFormChange: _pt.any,
  propagateUpdates: _pt.any,
  onRemove: _pt.func.isRequired,
  children: _pt.oneOfType([_pt.node, _pt.func])
});

var validators = [minLength(), maxLength()];
var validatorPropTypes = validators.reduce(function (acc, v) {
  return v.propTypes ? _objectSpread2(_objectSpread2({}, acc), v.propTypes) : acc;
}, {});

var getDefaultOptions = function getDefaultOptions() {
  return {
    defaultProps: {},
    displayName: function displayName(props) {
      return props.field;
    }
  };
};

var DEFAULT_ARRAY_KEY = "key";
/**
 * Higher-order function to create a form-connected array higher-order component
 * @param {Object} options Array options
 * @returns Array HOC
 */

var withFormArray = function withFormArray() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getDefaultOptions();
  return function (FormArrayComponent) {
    var _class, _temp;

    var defaultOptions = getDefaultOptions();
    var arrayDefaultProps = options.defaultProps || defaultOptions.defaultProps;
    return _temp = _class = /*#__PURE__*/function (_React$Component2) {
      _inherits(ArrayWrapper, _React$Component2);

      var _super2 = _createSuper(ArrayWrapper);

      function ArrayWrapper() {
        var _this2;

        _classCallCheck(this, ArrayWrapper);

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        _this2 = _super2.call.apply(_super2, [this].concat(args));

        _defineProperty(_assertThisInitialized(_this2), "_prevContext", void 0);

        _defineProperty(_assertThisInitialized(_this2), "_hasInnerObjectError", false);

        _defineProperty(_assertThisInitialized(_this2), "_validateOnUpdate", false);

        _defineProperty(_assertThisInitialized(_this2), "validate", function (props, context) {
          var comparePreviousErrors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
          var field = props.field,
              _props$arrayKey = props.arrayKey,
              arrayKey = _props$arrayKey === void 0 ? DEFAULT_ARRAY_KEY : _props$arrayKey;
          var contextValue = context.value || {};
          var contextErrors = context.errors || {};
          var fieldValue = contextValue[field] || [];
          var fieldErrors = contextErrors[field] || [];
          var fieldName = options.displayName ? options.displayName(props) : defaultOptions.displayName ? defaultOptions.displayName(props) : "";
          var previousArrayErrors = fieldErrors.filter(function (e) {
            return typeof e === "string";
          });
          var arrayErrors = validators.reduce(function (acc, v) {
            if (!v.getErrors) return acc;
            if (v.shouldValidate && !v.shouldValidate(props, context)) return acc;
            return [].concat(_toConsumableArray(acc), _toConsumableArray(v.getErrors(fieldName, fieldValue, props, context)));
          }, []);

          if (comparePreviousErrors) {
            // stop if errors unchanged
            if (shallowCompareArrays(previousArrayErrors, arrayErrors)) {
              return;
            }
          }

          var applyErrors = function applyErrors(prevErrors) {
            var _prevErrors$field; // merge existing child item errors


            var itemErrors = (_prevErrors$field = prevErrors[field]) === null || _prevErrors$field === void 0 ? void 0 : _prevErrors$field.filter(function (e) {
              return fieldValue.some(function (v) {
                return _typeof(e) === "object" && v[arrayKey] === e[arrayKey];
              });
            });
            return _objectSpread2(_objectSpread2({}, prevErrors), {}, _defineProperty({}, field, [].concat(_toConsumableArray(arrayErrors), _toConsumableArray(itemErrors !== null && itemErrors !== void 0 ? itemErrors : []))));
          };

          if (_this2.context.onError) {
            _this2.context.onError(field, arrayErrors, applyErrors);
          }
        });

        _defineProperty(_assertThisInitialized(_this2), "updateErrors", function (field, errors) {
          var applyErrors = function applyErrors(prevErrors) {
            var hasOldErrors = !!prevErrors && prevErrors.hasOwnProperty(field);
            var oldErrors = hasOldErrors ? prevErrors[field] : [];

            if (oldErrors === errors || Array.isArray(oldErrors) && shallowCompareArrays(oldErrors, errors)) {
              return prevErrors;
            }

            return _objectSpread2(_objectSpread2({}, prevErrors), {}, _defineProperty({}, field, errors));
          };

          if (_this2.context.onError) {
            _this2.context.onError(field, errors, applyErrors);
          }
        });

        _defineProperty(_assertThisInitialized(_this2), "objectOnChange", function (object, field, data, applyChanges, metadata) {
          var _ref;

          var _this2$props = _this2.props,
              arrayField = _this2$props.field,
              _this2$props$arrayKey = _this2$props.arrayKey,
              arrayKey = _this2$props$arrayKey === void 0 ? DEFAULT_ARRAY_KEY : _this2$props$arrayKey,
              autoRemove = _this2$props.autoRemove;
          var arrayData = [(_ref = {}, _defineProperty(_ref, arrayKey, object[arrayKey]), _defineProperty(_ref, "field", field), _defineProperty(_ref, "data", data), _ref)];

          var arrayApplyChanges = function arrayApplyChanges(prevValue) {
            var prevArrayValue = prevValue[arrayField] || [];

            var newArray = _toConsumableArray(prevArrayValue);

            var objectIndex = newArray.findIndex(function (v) {
              return v[arrayKey] === object[arrayKey];
            });

            if (objectIndex >= 0) {
              var updatedObject = applyChanges(newArray[objectIndex]);
              newArray[objectIndex] = updatedObject;

              if (autoRemove) {
                updatedObject[arrayKey];

                var otherObjectValues = _objectWithoutProperties(updatedObject, [arrayKey].map(_toPropertyKey));

                if (Object.values(otherObjectValues).every(function (v) {
                  return !isValueSet(v);
                })) {
                  newArray.splice(objectIndex, 1);
                }
              }
            } else {
              newArray.push(applyChanges(object)); // at the point of adding an auto item apply any errors

              if (_this2._nextAutoItem && Object.keys(_this2._nextAutoItemErrors).length > 0) {
                // ignore errors for the field(s) just changed, as the change will trigger re-validation
                var fieldArray = Array.isArray(field) ? field : [field];
                var autoItemErrors = fieldArray.reduce(function (acc, f) {
                  acc[f];

                  var remaining = _objectWithoutProperties(acc, [f].map(_toPropertyKey));

                  return remaining;
                }, _objectSpread2({}, _this2._nextAutoItemErrors));
                var arrayErrors = [_objectSpread2(_defineProperty({}, arrayKey, object[arrayKey]), autoItemErrors)];

                var arrayApplyErrors = function arrayApplyErrors(prevErrors) {
                  var prevArrayErrors = prevErrors[arrayField] || [];
                  return _objectSpread2(_objectSpread2({}, prevErrors), {}, _defineProperty({}, arrayField, [].concat(_toConsumableArray(prevArrayErrors), arrayErrors)));
                };

                if (_this2.context.onError) {
                  _this2.context.onError(arrayField, arrayErrors, arrayApplyErrors);
                }
              }

              _this2._nextAutoItem = null;
              _this2._nextAutoItemErrors = {};
            }

            if (prevValue && prevValue.hasOwnProperty(arrayField) && shallowCompareArrays(newArray, prevArrayValue)) {
              return prevValue;
            }

            return _objectSpread2(_objectSpread2({}, prevValue), {}, _defineProperty({}, arrayField, newArray));
          };

          if (_this2.context.onChange) {
            _this2.context.onChange(arrayField, arrayData, arrayApplyChanges, metadata);
          }
        });

        _defineProperty(_assertThisInitialized(_this2), "objectOnRemove", function (index) {
          var arrayField = _this2.props.field;

          var applyChanges = function applyChanges(prevValue) {
            var prevArrayValue = prevValue[arrayField] || [];

            var newArray = _toConsumableArray(prevArrayValue);

            newArray.splice(index, 1);
            return _objectSpread2(_objectSpread2({}, prevValue), {}, _defineProperty({}, arrayField, newArray));
          };

          var metadata = {
            source: FormChangeSource.Array
          };

          if (_this2.context.onChange) {
            var contextValue = _this2.context.value || {};

            _this2.context.onChange(arrayField, applyChanges(contextValue)[arrayField], applyChanges, metadata);
          }
        });

        _defineProperty(_assertThisInitialized(_this2), "objectOnError", function (object, field, errors, applyErrors) {
          var _ref2;

          var _this2$props2 = _this2.props,
              arrayField = _this2$props2.field,
              _this2$props2$arrayKe = _this2$props2.arrayKey,
              arrayKey = _this2$props2$arrayKe === void 0 ? DEFAULT_ARRAY_KEY : _this2$props2$arrayKe; // hold back auto item errors until item is actually added

          if (_this2._nextAutoItem && object[arrayKey] === _this2._nextAutoItem[arrayKey]) {
            _this2._nextAutoItemErrors = applyErrors(_this2._nextAutoItemErrors);
            return;
          }

          _this2._hasInnerObjectError = true;
          var arrayErrors = [(_ref2 = {}, _defineProperty(_ref2, arrayKey, object[arrayKey]), _defineProperty(_ref2, "field", field), _defineProperty(_ref2, "errors", errors), _ref2)];

          var arrayApplyErrors = function arrayApplyErrors(prevErrors) {
            var prevArray = prevErrors[arrayField] || [];

            var newArray = _toConsumableArray(prevArray);

            var objectKeyValue = object[arrayKey];
            var objectIndex = newArray.findIndex(function (v) {
              return _typeof(v) === "object" && v[arrayKey] === objectKeyValue;
            });

            if (objectIndex >= 0) {
              var foundItem = newArray[objectIndex];
              var itemWithErrors = applyErrors(foundItem);

              if (foundItem === itemWithErrors) {
                return prevErrors;
              }

              newArray[objectIndex] = itemWithErrors;
            } else {
              var newItem = _defineProperty({}, arrayKey, object[arrayKey]);

              var _itemWithErrors = applyErrors(newItem);

              if (newItem === _itemWithErrors) {
                return prevErrors;
              }

              newArray.push(_itemWithErrors);
            }

            return _objectSpread2(_objectSpread2({}, prevErrors), {}, _defineProperty({}, arrayField, newArray));
          };

          if (_this2.context.onError) {
            _this2.context.onError(arrayField, arrayErrors, arrayApplyErrors);
          }
        });

        _defineProperty(_assertThisInitialized(_this2), "getObjectErrorsByKey", memoizeOne(function (errors, arrayKey) {
          var objectErrors = errors.filter(function (e) {
            return _typeof(e) === "object";
          });
          return objectErrors.reduce(function (acc, e) {
            acc[e[arrayKey]] = e;
            return acc;
          }, {});
        }));

        _defineProperty(_assertThisInitialized(_this2), "_nextAutoItem", null);

        _defineProperty(_assertThisInitialized(_this2), "_nextAutoItemErrors", {});

        _defineProperty(_assertThisInitialized(_this2), "_defaultItemErrors", {});

        return _this2;
      }

      _createClass(ArrayWrapper, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          if (this._hasInnerObjectError) this._validateOnUpdate = true;else this.validate(this.props, this.context);
          this._prevContext = this.context;
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          // clear validation errors so unmounted components don't invalidate forms
          var field = this.props.field;
          this.updateErrors(field, []);
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
          var _this$_prevContext,
              _this3 = this;

          var currentContextValue = this.context.value || {};
          var prevContextValue = ((_this$_prevContext = this._prevContext) === null || _this$_prevContext === void 0 ? void 0 : _this$_prevContext.value) || {};
          var validate = currentContextValue[this.props.field] !== prevContextValue[prevProps.field] || this._validateOnUpdate;

          if (!validate) {
            // run validators if any validator props have changed
            var validatorPropKeys = Object.keys(validatorPropTypes);
            validate = validatorPropKeys.some(function (k) {
              return _this3.props[k] !== prevProps[k];
            });
          }

          if (validate) {
            this.validate(this.props, this.context, true);
          }

          this._prevContext = this.context;
          this._validateOnUpdate = false;
        }
      }, {
        key: "render",
        value: function render() {
          var _this$context$previou,
              _this4 = this;

          var _ref3 = this.props,
              field = _ref3.field,
              _ref3$arrayKey = _ref3.arrayKey,
              arrayKey = _ref3$arrayKey === void 0 ? DEFAULT_ARRAY_KEY : _ref3$arrayKey,
              showErrors = _ref3.showErrors,
              allErrors = _ref3.allErrors,
              animateErrors = _ref3.animateErrors,
              disabled = _ref3.disabled,
              readOnly = _ref3.readOnly,
              autoAdd = _ref3.autoAdd,
              autoAddPopulate = _ref3.autoAddPopulate,
              propagateUpdates = _ref3.propagateUpdates,
              children = _ref3.children,
              virtualized = _ref3.virtualized;
          var contextValue = this.context.value || {};
          var contextErrors = this.context.errors || {};
          var values = contextValue[field] || [];
          var errors = contextErrors[field] || [];
          var arrayErrors = errors.filter(function (e) {
            return typeof e === "string";
          });
          var objectErrors = this.getObjectErrorsByKey(errors, arrayKey);

          if (autoAdd && autoAddPopulate) {
            if (!this._nextAutoItem) {
              this._nextAutoItem = autoAddPopulate(arrayKey);
            }

            values = [].concat(_toConsumableArray(values), [this._nextAutoItem]);
          }

          var contextProps = {
            showErrors: showErrors !== undefined ? showErrors : this.context.showErrors,
            allErrors: allErrors !== undefined ? allErrors : this.context.allErrors,
            animateErrors: animateErrors !== undefined ? animateErrors : this.context.animateErrors,
            disabled: disabled !== undefined ? disabled : this.context.disabled,
            readOnly: readOnly !== undefined ? readOnly : this.context.readOnly,
            previousFormChange: (_this$context$previou = this.context.previousFormChange) !== null && _this$context$previou !== void 0 ? _this$context$previou : this.context.previousChange
          };
          var passThruProps = omitProps(this.props, Object.keys(ArrayWrapper.propTypes));

          var renderItemProvider = function renderItemProvider(v, i, content, additionalPropagateUpdatesDependencies) {
            var _objectErrors$v$array;

            if (v[arrayKey] === undefined) {
              throw new Error("ArrayField object missing ".concat(arrayKey, " property for ").concat(field, "[").concat(i, "]"));
            }

            return /*#__PURE__*/React.createElement(ArrayItemProvider, _extends({}, contextProps, {
              key: v[arrayKey],
              index: _this4._nextAutoItem && v[arrayKey] === _this4._nextAutoItem[arrayKey] ? undefined : i,
              value: v,
              parentValue: contextValue,
              formValue: _this4.context.formValue || contextValue,
              onChange: _this4.objectOnChange,
              onRemove: _this4.objectOnRemove,
              errors: (_objectErrors$v$array = objectErrors[v[arrayKey]]) !== null && _objectErrors$v$array !== void 0 ? _objectErrors$v$array : _this4._defaultItemErrors,
              onError: _this4.objectOnError,
              propagateUpdates: Array.isArray(propagateUpdates) && Array.isArray(additionalPropagateUpdatesDependencies) ? [].concat(_toConsumableArray(propagateUpdates), _toConsumableArray(additionalPropagateUpdatesDependencies)) : propagateUpdates !== null && propagateUpdates !== void 0 ? propagateUpdates : additionalPropagateUpdatesDependencies
            }), content);
          };

          return /*#__PURE__*/React.createElement(FormArrayComponent, _extends({}, this.props, contextProps, {
            value: values,
            errors: arrayErrors,
            passThruChildren: children,
            passThruProps: passThruProps,
            renderItem: function renderItem(v, i) {
              var overrideContent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
              var additionalDependencies = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
              return renderItemProvider(v, i, overrideContent !== null && overrideContent !== void 0 ? overrideContent : children, additionalDependencies);
            }
          }), virtualized ? undefined : values.map(function (v, i) {
            return renderItemProvider(v, i, children);
          }));
        }
      }]);

      return ArrayWrapper;
    }(React.Component), _defineProperty(_class, "propTypes", {}), _defineProperty(_class, "defaultProps", _objectSpread2({
      arrayKey: DEFAULT_ARRAY_KEY,
      autoAdd: false,
      autoAddPopulate: function autoAddPopulate(arrayKey) {
        return _defineProperty({}, arrayKey, Date.now());
      },
      autoRemove: false
    }, arrayDefaultProps)), _defineProperty(_class, "contextType", FormContext$1), _defineProperty(_class, "displayName", "withFormArray(".concat(FormArrayComponent.displayName || FormArrayComponent.name, ")")), _temp;
  };
};

var withFormArray$1 = withFormArray;

export { withFormArray$1 as default };
